import React from 'react';
import {
  Box,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { sectionCard, sectionStack, titleRow } from '../styles';

interface SettingsSectionProps {
  title: React.ReactNode;
  tooltip?: string;
  children: React.ReactNode;
}

const SettingsSection: React.FC<SettingsSectionProps> = ({
  title,
  tooltip,
  children,
}) => (
  <Paper variant="outlined" sx={sectionCard}>
    <Stack sx={sectionStack}>
      <Box sx={titleRow}>
        <Typography variant="h6">{title}</Typography>
        {tooltip ? (
          <Tooltip title={tooltip} placement="right" arrow>
            <IconButton size="small" aria-label="Section info">
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        ) : null}
      </Box>
      {children}
    </Stack>
  </Paper>
);

export { SettingsSection };
